import React, { useRef } from 'react';
import ImageGallery from 'react-image-gallery';
import 'react-image-gallery/styles/css/image-gallery.css'; // Importer les styles par défaut

import aménagement_plateau_bureau_Sidi_Maaro_1 from '../images/projets/aménagement_plateau_bureau_Sidi_Maaro_1.jpg'
import aménagement_plateau_bureau_Sidi_Maaro_2 from '../images/projets/aménagement_plateau_bureau_Sidi_Maaro_2.jpg'
import aménagement_plateau_bureau_Sidi_Maaro_3 from '../images/projets/aménagement_plateau_bureau_Sidi_Maaro_3.jpg'
import amenagemenent_buréeau from '../images/projets/amenagemenent_buréeau.mp4'




import { Box, Divider, Typography } from '@mui/material';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Avatar from '@mui/material/Avatar';
import ImageIcon from '@mui/icons-material/Image';
import WorkIcon from '@mui/icons-material/Work';
import BeachAccessIcon from '@mui/icons-material/BeachAccess';
import Footer from '../Components/Footer';
import { useEffect } from 'react';
import { Trans } from 'react-i18next';

export default function BureauProject({t}) {
  useEffect(() => {
    // Réinitialiser la position de défilement à 0
    window.scrollTo(0, 0);




  
    return () => {
     
    };
  }, []);
    const galleryRef = useRef(null); // Référence au composant ImageGallery

    const images = [
        {
            original: aménagement_plateau_bureau_Sidi_Maaro_1,
            thumbnail: aménagement_plateau_bureau_Sidi_Maaro_1,
        },
        {
            original:amenagemenent_buréeau, 
            thumbnail: aménagement_plateau_bureau_Sidi_Maaro_2, // Miniature de la vidéo
            embed: true, 
        },
        {
            original: aménagement_plateau_bureau_Sidi_Maaro_3,
            thumbnail: aménagement_plateau_bureau_Sidi_Maaro_3,
        },
      
     
  
    ];
    //construction-centreculturel-Berkane.html
    
    const renderGalleryItem = (item) => {
      if (item.embed) {
          return (
              <div>
                  <video controls style={{ width: '100%' }}>
                      <source src={item.original} type="video/mp4" />
                      Votre navigateur ne supporte pas la lecture de vidéos.
                  </video>
              </div>
          );
      }

      return <img src={item.original} alt={item.thumbnail} style={{ width: '100%' }} />;
  };
    return (
        <>
           <Typography variant='h4'  color='#424242' sx={{fontFamily: 'Montserrat, sans-serif', paddingTop:'48px', margin: '0 5%'}}><Trans i18nKey="bureau Sidi Maarouf" /></Typography>
       
        
        <div style={{ maxWidth: '800px', margin: '0 5%' }}>
           
            <div style={{ marginBottom: '20px',paddingTop:'48px' }}>
                <ImageGallery
                    ref={galleryRef} // Référence au composant
                    items={images}
                    showNav={false} // Masquer la navigation
                    showPlayButton={false} // Masquer le bouton de lecture
                    showFullscreenButton={false} // Masquer le bouton plein écran
                    showBullets={false} 
                    showThumbnails={false}
                    slideDuration={300} 
                    thumbnailPosition="bottom" // Position des miniatures
                    slideInterval={3000} 
                    renderItem={renderGalleryItem}
                    renderLeftNav={() => null} 
                    renderRightNav={() => null} 
                    thumbnailClass="custom-thumbnail" 
                   
                />
            </div>
            <div className="thumbnails">
                {images.map((image, index) => (
                    <img
                        key={index}
                        src={image.thumbnail}
                        alt={`Thumbnail ${index}`}
                        style={{
                            width: '100px',
                            height: '100px',
                            margin: '0 5px',
                            cursor: 'pointer',
                            border: '2px solid #ddd',
                            borderRadius: '5px',
                            objectFit:'cover'
                        }}
                        onClick={() => galleryRef.current.slideToIndex(index)} 
                    />
                ))}
            </div>
        </div>
        <Box sx={{paddingLeft:'4%', paddingTop:'48px'}}>
        <List sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}>
      <ListItem>
        <ListItemAvatar>
        <Avatar sx={{ bgcolor:'white'}}  > 
          📏
          </Avatar>
        </ListItemAvatar>
        <ListItemText primary={t("Surface réalisée")} secondary="500 m²" />
      </ListItem>
      <Divider variant="inset" component="li" />
      <ListItem>
       
        <ListItemAvatar>
        <Avatar sx={{ bgcolor:'white'}}  > 
          🏙️
          </Avatar>
        </ListItemAvatar>
        <ListItemText primary={t("Ville")} secondary="Casablanca" />
      </ListItem>
      <Divider variant="inset" component="li" />
      <ListItem>
        <ListItemAvatar>
        <Avatar sx={{ bgcolor:'white'}}  > 
          📚
            
          </Avatar>
        </ListItemAvatar>
        <ListItemText primary="Mission" secondary={t("Conception architecturale, études techniques et OPC")} />
      </ListItem>
      <Divider variant="inset" component="li" />
      <ListItem>
        <ListItemAvatar>
          <Avatar sx={{ bgcolor:'white'}}  > 
          📅
          </Avatar >
        </ListItemAvatar>
        <ListItemText primary="Date" secondary="2024" />
      </ListItem>
      <Divider variant="inset" component="li" />
    
    </List>
        </Box>
        <Footer />
        </>
    );
}
